export class ReplaceProtectionPricingCardCommand {
	id: number;
	approvedAmount: number;
	flaggedAmount: number;
	rejectedAmount: number;
	cancelledAmount: number;
}
